/* Vonkron theme behaviour */
(function () {
  'use strict';
  var Routes = window.VonkronRoutes || {};

  function $(s, c) { return (c || document).querySelector(s); }
  function $$(s, c) { return Array.prototype.slice.call((c || document).querySelectorAll(s)); }

  function formatMoney(cents) {
    var fmt = window.VonkronMoneyFormat || '${{amount}}';
    var v = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    var n = (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 0, maximumFractionDigits: 0 });
    return fmt.replace(/\{\{\s*amount\s*\}\}/g, v)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/g, n)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/g, v)
      .replace(/\{\{\s*amount_no_decimals_with_comma_separator\s*\}\}/g, n);
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  function getCart() {
    return fetch(Routes.cart + '.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  /* ---------- flash ---------- */
  var flashTimer;
  function flash(msg) {
    var el = $('#Flash'); if (!el) return;
    $('.flash-msg', el).textContent = msg;
    el.classList.remove('hide');
    clearTimeout(flashTimer);
    flashTimer = setTimeout(function () { el.classList.add('hide'); }, 2600);
  }

  /* ---------- cart drawer ---------- */
  function openDrawer() {
    var d = $('[data-cart-drawer]'), s = $('[data-drawer-scrim]');
    if (!d) return;
    d.classList.add('open'); d.setAttribute('aria-hidden', 'false');
    if (s) s.classList.add('open');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    var d = $('[data-cart-drawer]'), s = $('[data-drawer-scrim]');
    if (d) { d.classList.remove('open'); d.setAttribute('aria-hidden', 'true'); }
    if (s) s.classList.remove('open');
    document.body.style.overflow = '';
  }
  function applyDrawerHTML(html) {
    if (!html) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cd-contents]');
    var cur = $('[data-cd-contents]');
    if (fresh && cur) cur.replaceWith(fresh);
  }
  function refreshDrawer() {
    return fetch('?sections=cart-drawer', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (data) { if (data && data['cart-drawer']) applyDrawerHTML(data['cart-drawer']); });
  }

  function addToCart(variantId, quantity) {
    return fetch(Routes.cartAdd, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: Number(variantId), quantity: quantity || 1 }], sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json().then(function (d) { if (!r.ok) throw d; return d; }); });
  }
  function changeLine(key, quantity) {
    return fetch(Routes.cartChange, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity, sections: ['cart-drawer'], sections_url: window.location.pathname })
    }).then(function (r) { return r.json(); });
  }

  function afterAdd(data, title) {
    if (data && data.sections) applyDrawerHTML(data.sections['cart-drawer']);
    getCart().then(function (c) { updateCartCount(c.item_count); }).catch(function () {});
    openDrawer();
  }

  /* ---------- drawer + global cart events ---------- */
  function initCartEvents() {
    document.addEventListener('click', function (e) {
      // open drawer from bag icon
      var toggle = e.target.closest('[data-cart-toggle]');
      if (toggle) { e.preventDefault(); refreshDrawer().then(openDrawer); return; }
      // close drawer
      if (e.target.closest('[data-drawer-close]') || e.target.closest('[data-drawer-scrim]')) { closeDrawer(); return; }
      // line quantity change (drawer or cart page)
      var step = e.target.closest('[data-line-step]');
      if (step) {
        var k = step.getAttribute('data-key'); var q = parseInt(step.getAttribute('data-new-qty'), 10);
        step.disabled = true;
        changeLine(k, q).then(function (cart) { updateCartCount(cart.item_count); if (cart.sections) applyDrawerHTML(cart.sections['cart-drawer']); refreshCartPage(); });
        return;
      }
      var rem = e.target.closest('[data-line-remove]');
      if (rem) {
        var rk = rem.getAttribute('data-key'); rem.disabled = true;
        changeLine(rk, 0).then(function (cart) { updateCartCount(cart.item_count); if (cart.sections) applyDrawerHTML(cart.sections['cart-drawer']); refreshCartPage(); });
        return;
      }
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
  }

  /* ---------- quick add (cards) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.js-quick-add');
      if (!btn) return;
      e.preventDefault(); e.stopPropagation();
      var id = btn.getAttribute('data-variant-id'); if (!id) return;
      btn.disabled = true; var orig = btn.textContent; btn.textContent = 'Adding…';
      addToCart(id, 1).then(function (data) {
        afterAdd(data, btn.getAttribute('data-product-title'));
        btn.textContent = orig; btn.disabled = false;
      }).catch(function (err) { flash((err && err.description) || 'Could not add to bag'); btn.textContent = orig; btn.disabled = false; });
    });
  }

  /* ---------- cart page (full) AJAX refresh ---------- */
  function refreshCartPage() {
    var root = $('[data-cart-root]'); if (!root) return;
    fetch(Routes.cart + '?section_id=main-cart').then(function (r) { return r.text(); }).then(function (html) {
      var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-cart-root]');
      if (fresh) root.replaceWith(fresh);
    });
  }

  /* ---------- accordions ---------- */
  function initAccordions() {
    document.addEventListener('click', function (e) {
      var hd = e.target.closest('.acc-hd'); if (!hd) return;
      hd.closest('.acc').classList.toggle('open');
    });
  }

  /* ---------- mobile nav ---------- */
  function initNav() {
    var toggle = $('.nav-toggle'), links = $('.nav-links'), scrim = $('.nav-scrim');
    if (!toggle || !links) return;
    function close() { links.classList.remove('open'); if (scrim) scrim.classList.remove('open'); document.documentElement.classList.remove('nav-open'); toggle.setAttribute('aria-expanded', 'false'); }
    function open() { links.classList.add('open'); if (scrim) scrim.classList.add('open'); document.documentElement.classList.add('nav-open'); toggle.setAttribute('aria-expanded', 'true'); }
    toggle.addEventListener('click', function () { links.classList.contains('open') ? close() : open(); });
    if (scrim) scrim.addEventListener('click', close);
    var cb = $('.js-nav-close', links); if (cb) cb.addEventListener('click', close);
    $$('a', links).forEach(function (a) { a.addEventListener('click', close); });
  }

  /* ---------- product page ---------- */
  function initProduct() {
    var root = $('[data-product-page]'); if (!root) return;
    var variantEl = root.querySelector('[data-variants]');
    var variants = []; try { variants = JSON.parse(variantEl ? variantEl.textContent : '[]'); } catch (e) {}
    var current = variants.find(function (v) { return v.available; }) || variants[0];
    var preselect = root.getAttribute('data-selected-variant');
    if (preselect) { var f = variants.find(function (v) { return String(v.id) === String(preselect); }); if (f) current = f; }

    var priceEl = $('[data-price]', root), compareEl = $('[data-compare]', root), saleEl = $('[data-sale]', root), colorLabel = $('[data-color-label]', root);
    var buyBtn = $('[data-buy]', root), buyPrice = $('[data-buy-price]', root), qtyEl = $('[data-qty]', root), mainImg = $('[data-gallery-main]', root);
    var qty = 1;
    var sticky = $('[data-sticky-atc]'), stickyPrice = sticky ? $('[data-sticky-price]', sticky) : null, stickyBtn = sticky ? $('[data-sticky-buy]', sticky) : null;

    function findVariant(color) { return variants.find(function (v) { return v.options.indexOf(color) !== -1; }) || current; }
    function setBuyLabel(t) { var l = $('[data-buy-label]', buyBtn); if (l) l.textContent = t; }

    function render() {
      if (!current) return;
      if (priceEl) priceEl.textContent = formatMoney(current.price);
      var onSale = current.compare_at_price && current.compare_at_price > current.price;
      if (compareEl) {
        if (onSale) { compareEl.textContent = formatMoney(current.compare_at_price); compareEl.style.display = ''; }
        else compareEl.style.display = 'none';
      }
      if (saleEl) { saleEl.style.display = onSale ? '' : 'none'; }
      if (buyPrice) buyPrice.textContent = formatMoney(current.price * qty);
      if (stickyPrice) stickyPrice.textContent = formatMoney(current.price);
      if (buyBtn) { buyBtn.disabled = !current.available; if (!current.available) setBuyLabel('Sold out'); }
      if (stickyBtn) stickyBtn.disabled = !current.available;
    }

    $$('.cdot', root).forEach(function (dot) {
      dot.addEventListener('click', function () {
        if (dot.disabled) return;
        $$('.cdot', root).forEach(function (d) { d.classList.remove('on'); });
        dot.classList.add('on');
        var val = dot.getAttribute('data-value');
        if (colorLabel) colorLabel.textContent = val;
        current = findVariant(val);
        if (mainImg) {
          var img = mainImg.querySelector('img');
          var src = current && current.featured_image ? current.featured_image.src : null;
          if (src && img) { img.src = src; img.srcset = ''; }
          else if (!src) { mainImg.className = 'gallery-main bagimg cw-' + (val || 'default').toLowerCase().replace(/[^a-z]/g, ''); }
        }
        render();
      });
    });

    $$('.thumb', root).forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        $$('.thumb', root).forEach(function (t) { t.classList.remove('on'); });
        thumb.classList.add('on');
        if (!mainImg) return;
        var imgUrl = thumb.getAttribute('data-image'), cw = thumb.getAttribute('data-cw');
        if (imgUrl) { var img = mainImg.querySelector('img'); if (img) { img.src = imgUrl; img.srcset = ''; } }
        else if (cw) { mainImg.className = 'gallery-main bagimg cw-' + cw; }
      });
    });

    $$('[data-qty-step]', root).forEach(function (b) {
      b.addEventListener('click', function () { qty = Math.max(1, qty + parseInt(b.getAttribute('data-qty-step'), 10)); if (qtyEl) qtyEl.textContent = qty; render(); });
    });

    function doAdd(useQty) {
      if (!current || !current.available) return;
      addToCart(current.id, useQty).then(function (data) {
        afterAdd(data, root.getAttribute('data-product-title'));
        if (buyBtn) { buyBtn.classList.add('added'); setBuyLabel('Added'); setTimeout(function () { buyBtn.classList.remove('added'); setBuyLabel('Add to bag'); render(); }, 1600); }
      }).catch(function (err) { flash((err && err.description) || 'Could not add to bag'); });
    }
    if (buyBtn) buyBtn.addEventListener('click', function () { doAdd(qty); });
    if (stickyBtn) stickyBtn.addEventListener('click', function () { doAdd(1); });

    // show sticky bar when main buy button scrolls out of view
    if (sticky && buyBtn && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { sticky.classList.toggle('show', !en.isIntersecting); });
      }, { rootMargin: '0px 0px -40px 0px' });
      io.observe(buyBtn);
    }
    render();
  }

  /* ---------- shop filters: jump to products on mobile ---------- */
  function initShopFilters() {
    var main = $('#ProductGrid');
    if (main) {
      // arriving after a filter tap on mobile -> scroll to products
      try {
        if (window.innerWidth <= 760 && sessionStorage.getItem('vonkron_jump') === '1') {
          sessionStorage.removeItem('vonkron_jump');
          requestAnimationFrame(function () { main.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
        }
      } catch (e) {}
    }
    // mark intent before the filter navigation reloads the page
    document.addEventListener('click', function (e) {
      if (window.innerWidth > 760) return;
      if (e.target.closest('.fcat') || e.target.closest('.fcolor') || e.target.closest('.clearf')) {
        try { sessionStorage.setItem('vonkron_jump', '1'); } catch (er) {}
      }
    });
    var sortSel = $('.sortsel select');
    if (sortSel) sortSel.addEventListener('change', function () { if (window.innerWidth <= 760) { try { sessionStorage.setItem('vonkron_jump', '1'); } catch (e) {} } });
  }

  /* ---------- newsletter ---------- */
  function initNewsletter() {
    if (window.location.search.indexOf('customer_posted=true') !== -1) {
      var done = $('[data-news-done]'), form = $('[data-news-form]');
      if (done) done.style.display = 'flex'; if (form) form.style.display = 'none';
    }
  }

  /* ---------- category showcase (full-screen snap, one scroll per category) ---------- */
  function initCatSnap() {
    var sec = $('[data-catsnap]'); if (!sec) return;
    var panels = $$('[data-panel]', sec), dots = $$('[data-dot]', sec);
    var n = panels.length; if (!n) return;
    var cur = -1, ticking = false;
    function activate(i) {
      if (i === cur) return; cur = i;
      panels.forEach(function (p, k) { p.classList.toggle('in', k === i); });
      dots.forEach(function (d, k) { d.classList.toggle('active', k === i); });
    }
    function update() {
      ticking = false;
      var r = sec.getBoundingClientRect();
      var total = sec.offsetHeight - window.innerHeight;
      var p = total > 0 ? (-r.top) / total : 0;
      if (p < 0) p = 0; if (p > 0.9999) p = 0.9999;
      activate(Math.floor(p * n));
    }
    function onScroll() { if (!ticking) { ticking = true; requestAnimationFrame(update); } }
    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onScroll);
    dots.forEach(function (d, k) {
      d.addEventListener('click', function () {
        var total = sec.offsetHeight - window.innerHeight;
        window.scrollTo({ top: sec.offsetTop + total * (k + 0.5) / n, behavior: 'smooth' });
      });
    });
    update();

    // per-category product carousel: arrows + horizontal drag-to-scroll
    $$('.cs-carousel', sec).forEach(function (car) {
      var track = $('[data-cs-track]', car); if (!track) return;
      function step() { var c = track.querySelector('.cs-card'); return c ? c.offsetWidth + 18 : 240; }
      var prev = $('.cs-prev', car), next = $('.cs-next', car);
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step() * 1.5, behavior: 'smooth' }); });
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step() * 1.5, behavior: 'smooth' }); });
      var down = false, startX = 0, startLeft = 0, moved = 0;
      // Only capture once an actual drag is detected, so taps still open the card.
      track.addEventListener('pointerdown', function (e) { down = true; moved = 0; startX = e.clientX; startLeft = track.scrollLeft; });
      track.addEventListener('pointermove', function (e) {
        if (!down) return;
        var dx = e.clientX - startX; moved = Math.abs(dx);
        if (moved > 6) {
          if (!track.hasPointerCapture(e.pointerId)) track.setPointerCapture(e.pointerId);
          track.classList.add('dragging');
        }
        track.scrollLeft = startLeft - dx;
      });
      function end() { down = false; setTimeout(function () { track.classList.remove('dragging'); }, 30); }
      track.addEventListener('pointerup', end);
      track.addEventListener('pointercancel', end);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initNav();
    initCartEvents();
    initQuickAdd();
    initAccordions();
    initProduct();
    initCatSnap();
    initShopFilters();
    initNewsletter();
    getCart().then(function (c) { updateCartCount(c.item_count); }).catch(function () {});
  });
})();
